type MedicineDetailsAdditionalInformationSections =
   | 'address'
   | 'atcCodes'
   | 'distributor'
   | 'eanCode'
   | 'email'
   | 'faxNumber'
   | 'manufacturer'
   | 'phoneNumber'
   | 'prescriptionType'
   | 'prescriptionTypeDescription'
   | 'productType'
   | 'registrationCertificateNumber'
   | 'therapeuticClass'
   | 'websiteAddress';

export const ORDERED_ADDITIONAL_INFORMATION_ACCORDION_SECTIONS: MedicineDetailsAdditionalInformationSections[] = [
   'therapeuticClass',
   'prescriptionType',
   'prescriptionTypeDescription',
   'productType',
   'atcCodes',
   'eanCode',
   'registrationCertificateNumber',
   'manufacturer',
   'websiteAddress',
   'address',
   'phoneNumber',
   'email',
   'faxNumber',
   'distributor',
];

export type MedicineDetailsSections =
   | 'reimbursements'
   | 'indications'
   | 'contraindications'
   | 'composition'
   | 'effects'
   | 'dosage'
   | 'warnings'
   | 'pregnancyAndLactationInfo'
   | 'sideEffects'
   | 'interactions'
   | 'notes'
   | 'additionalMedicineInformation';

export const ORDERED_MEDICINE_DETAILS_ACCORDION_SECTIONS: MedicineDetailsSections[] = [
   'reimbursements',
   'indications',
   'contraindications',
   'composition',
   'effects',
   'dosage',
   'warnings',
   'pregnancyAndLactationInfo',
   'sideEffects',
   'interactions',
   'notes',
   'additionalMedicineInformation',
];
